import { j as l } from "./AccesRecoveryIcon-CUPieIxT.js";
const i = () => /* @__PURE__ */ l.jsxs("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ l.jsxs("g", { clipPath: "url(#clip0_10006_128829)", children: [
    /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.40929 38.5188V22.6742L9.57372 22.8573L10.0305 23.3333L10.5379 23.8123L11.1072 24.2957L11.6821 24.7331L11.6821 36.8462L19.6372 30.378L27.5922 36.8462V24.7331L28.1921 24.2756L28.7714 23.7808L29.3371 23.2398L29.865 22.6742V38.5188C29.865 39.7637 28.4215 40.4512 27.456 39.6662L19.6372 33.3087L11.8183 39.6662C10.8528 40.4512 9.40929 39.7637 9.40929 38.5188Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.6372 25.0198C25.9135 25.0198 31.0014 19.9281 31.0014 13.6472C31.0014 7.36624 25.9135 2.27452 19.6372 2.27452C13.3608 2.27452 8.27286 7.36624 8.27286 13.6472C8.27286 19.9281 13.3608 25.0198 19.6372 25.0198ZM19.6372 27.2943C27.1687 27.2943 33.2743 21.1843 33.2743 13.6472C33.2743 6.11005 27.1687 0 19.6372 0C12.1056 0 6 6.11005 6 13.6472C6 21.1843 12.1056 27.2943 19.6372 27.2943Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.6372 20.4707C24.1829 20.4707 26.4557 18.1962 26.4557 13.6472C26.4557 9.0981 23.6147 6.82358 19.6372 6.82358C15.6596 6.82358 12.8186 9.0981 12.8186 13.6472C12.8186 18.1962 15.0914 20.4707 19.6372 20.4707ZM19.6372 22.7453C25.3193 22.7453 28.7286 19.3335 28.7286 13.6472C28.7286 7.96096 25.3193 4.54905 19.6372 4.54905C13.955 4.54905 10.5457 7.96084 10.5457 13.6472C10.5457 19.3335 13.955 22.7453 19.6372 22.7453Z",
        fill: "currentColor"
      }
    )
  ] }),
  /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_10006_128829", children: /* @__PURE__ */ l.jsx("rect", { width: "27.2743", height: "40", fill: "white", transform: "translate(6)" }) }) })
] });
export {
  i as R
};
